// prettier-ignore
module.exports = {
  bugsnagApiKey:        process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
  buildGitHash:         process.env.NEXT_PUBLIC_GIT_COMMIT_SHA,
  buildGitHashShort:    (process.env.NEXT_PUBLIC_GIT_COMMIT_SHA ?? '').slice(0, 7),
  frontAppDomain:       process.env.NEXT_PUBLIC_FRONT_APP_DOMAIN,
  vercelEnvironment:    process.env.NEXT_PUBLIC_VERCEL_ENV,
};
